import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class EbClaimHistoryService {

  routePrefix = '/api/eb-claim-history';
  constructor(private http: HttpClient) { }

  getClaimHistoryDetails(): Observable<any>{
    return this.http.get<any>(this.routePrefix + '/');
  }

  getClaimStatusDetails(claimEntryId:number): Observable<any>{
    return this.http.get<any>(this.routePrefix + '/' + claimEntryId + '/claim-status-details');
  }
}
